export const PAY_PLATFORM_OPTIONS = [
  { value: 1, label: 'Google' },
  { value: 2, label: 'Apple' },
  { value: 3, label: 'Antom' },
  { value: 4, label: 'Stripe' },
  { value: 5, label: 'PayPal' }
]

export const OPERATION_TYPE_OPTIONS = [
  { value: 1, label: '退款', color: 'warning' },
  { value: 2, label: '补单', color: 'primary' },
  { value: 3, label: '取消订阅', color: 'error' }
]

export const OPERATION_STATUS_OPTIONS = [
  { value: 0, label: '已创建', color: 'default' },
  { value: 1, label: '处理中', color: 'primary' },
  { value: 2, label: '成功', color: 'success' },
  { value: 3, label: '失败', color: 'error' },
  { value: 4, label: '需人工处理', color: 'warning' }
]

export const EQUITY_STATUS_OPTIONS = [
  { value: 0, label: '无需处理', color: 'default' },
  { value: 1, label: '待处理', color: 'warning' },
  { value: 2, label: '处理成功', color: 'success' },
  { value: 3, label: '处理失败', color: 'error' }
]

export const SUBSCRIPTION_STATUS_OPTIONS = [
  { value: 0, label: '已创建未付款', color: 'default' },
  { value: 1, label: '有效', color: 'success' },
  { value: 2, label: '已取消', color: 'warning' },
  { value: 3, label: '已过期', color: 'default' },
  { value: 4, label: '已暂停', color: 'warning' },
  { value: 5, label: '扣款失败', color: 'error' }
]

export const PAY_STATUS_OPTIONS = [
  { value: 0, label: '支付成功', color: 'success' },
  { value: 1, label: '取消支付', color: 'default' },
  { value: 2, label: '支付失败', color: 'error' },
  { value: 3, label: '未支付', color: 'warning' },
  { value: 4, label: '超时未支付', color: 'default' }
]

export const REFUND_STATUS_OPTIONS = [
  { value: 0, label: '未退款', color: 'default' },
  { value: 1, label: '退款处理中', color: 'primary' },
  { value: 2, label: '部分退款成功', color: 'warning' },
  { value: 3, label: '全额退款成功', color: 'success' },
  { value: 4, label: '退款失败', color: 'error' },
  { value: 5, label: '退款撤销', color: 'default' }
]

export const GOODS_TYPE_OPTIONS = [
  { value: 0, label: '充值金币' },
  { value: 1, label: 'VIP' },
  { value: 2, label: '通行证' }
]

export const SUPPLEMENT_SCENE_OPTIONS = [
  { value: 1, label: '补建订阅续订订单' },
  { value: 2, label: '补发缺失权益' },
  { value: 3, label: '修正订单支付成功' }
]

export const OVERVIEW_SCOPE_OPTIONS = [
  { value: 'ALL', label: '总处理客诉', color: '#1677ff' },
  { value: 'TODAY', label: '今日处理', color: '#52c41a' },
  { value: 'WEEK', label: '本周处理', color: '#722ed1' },
  { value: 'MONTH', label: '本月处理', color: '#fa8c16' }
]

export const findOption = (options, value) => {
  return options.find((item) => item.value === value)
}

export const getOptionLabel = (options, value, fallback = '-') => {
  const option = findOption(options, value)
  return option ? option.label : fallback
}

export const getOptionColor = (options, value, fallback = 'default') => {
  const option = findOption(options, value)
  return option && option.color ? option.color : fallback
}

export const compactObject = (source) => {
  const result = {}
  Object.keys(source).forEach((key) => {
    const value = source[key]
    if (value !== '' && value !== null && value !== undefined) {
      result[key] = value
    }
  })
  return result
}

export const displayValue = (value, fallback = '-') => {
  if (value === 0 || value === false) return value
  return value || fallback
}

export const formatDateTime = (value) => {
  if (!value) return '-'
  return String(value)
    .replace('T', ' ')
    .replace(/(\.\d+)?Z$/, '')
}

export const formatAmount = (amount, currency) => {
  const value = Number(amount)
  if (Number.isNaN(value)) return '-'
  return `${currency || 'USD'} ${value.toFixed(2)}`
}

export const formatCompactAmount = (amount, currency) => {
  const value = Number(amount)
  if (Number.isNaN(value)) return '-'
  const code = currency === 'USD' ? '$' : currency || 'USD'
  return `${code}${value.toFixed(2)}`
}

export const getPayPlatformLabel = (value) =>
  getOptionLabel(PAY_PLATFORM_OPTIONS, value)

export const getGoodsTypeLabel = (value) =>
  getOptionLabel(GOODS_TYPE_OPTIONS, value)

export const getPayStatusLabel = (value) =>
  getOptionLabel(PAY_STATUS_OPTIONS, value)

export const getPayStatusColor = (value) =>
  getOptionColor(PAY_STATUS_OPTIONS, value)

const normalizeRefundStatus = (value) =>
  value === null || value === undefined ? 0 : value

export const getRefundStatusLabel = (value) =>
  getOptionLabel(REFUND_STATUS_OPTIONS, normalizeRefundStatus(value))

export const getRefundStatusColor = (value) =>
  getOptionColor(REFUND_STATUS_OPTIONS, normalizeRefundStatus(value))

export const getSubscriptionStatusLabel = (value) =>
  getOptionLabel(SUBSCRIPTION_STATUS_OPTIONS, value)

export const getSubscriptionStatusColor = (value) =>
  getOptionColor(SUBSCRIPTION_STATUS_OPTIONS, value)

export const getOperationTypeLabel = (value) =>
  getOptionLabel(OPERATION_TYPE_OPTIONS, value)

export const getOperationTypeColor = (value) =>
  getOptionColor(OPERATION_TYPE_OPTIONS, value)

export const getOperationStatusLabel = (value) =>
  getOptionLabel(OPERATION_STATUS_OPTIONS, value)

export const getOperationStatusColor = (value) =>
  getOptionColor(OPERATION_STATUS_OPTIONS, value)

export const getEquityStatusLabel = (value) =>
  getOptionLabel(EQUITY_STATUS_OPTIONS, value)

export const getEquityStatusColor = (value) =>
  getOptionColor(EQUITY_STATUS_OPTIONS, value)
